import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as dayjs from 'dayjs';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  BoxContainer,
  Header,
  Body,
  CalendarContainer,
  NoResultContainer,
  SelectedDate,
  PlannedListGrid,
  EventCard,
} from './style';
import routes from '../../../routes';
import { Icon, NoResult, Text } from '../../../ui/atoms';
import {
  EVENT_DATES_LIST_GET,
  SESSIONS_LIST_GET,
} from '../../redux/actions/events';
import {
  getEventDates,
  getFilterDates,
  todayHasEvents,
} from '../../../utils/events';
import { timestampToDate } from '../../../utils/common';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import ModalEvents, {
  ModalEventsId,
} from '../../../ui/atoms/Modals/ModalEvents';
import { MODAL_OPEN } from '../../redux/actions';

const LearningEvents = ({
  mediaIsPhone,
  getEventsList,
  eventDates,
  getEventDatesList,
  sessions,
  modalOpen,
}) => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    getEventDatesList(getEventDates());
    getEventsList(getFilterDates());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClickDate = (date) => {
    const current_date = dayjs(date).format('DD-MM-YYYY');
    if (mediaIsPhone) {
      getEventsList({ start_date: current_date, end_date: current_date });
      modalOpen(ModalEventsId, { date });
      return;
    }
    const dateTimestamp = dayjs(date).unix();
    if (selectedDate !== dateTimestamp) {
      getEventsList({ start_date: current_date, end_date: current_date });
      setSelectedDate(dateTimestamp);
    } else {
      getEventsList(getFilterDates());
      setSelectedDate();
    }
  };

  const getCalendarClasses = ({ date }) => {
    let classes = '';
    if (todayHasEvents({ date, eventDates })?.length > 0) {
      classes += 'active ';
    }
    if (
      dayjs(new Date(date)).isSame(dayjs(new Date(selectedDate * 1000)), 'day')
    ) {
      classes += 'selected';
    }
    return classes;
  };

  const onChangeMonth = (date) => {
    const current_date = dayjs(date?.activeStartDate).unix();
    getEventDatesList(getEventDates(current_date));
  };

  return (
    <PlannedListGrid>
      <div>
        <CalendarContainer>
          <Calendar
            view="month"
            tileClassName={getCalendarClasses}
            onClickDay={onClickDate}
            onActiveStartDateChange={onChangeMonth}
            formatShortWeekday={(_locale, dateValue) =>
              ['D', 'L', 'M', 'M', 'G', 'V', 'S'][dateValue.getDay()]
            }
          />
        </CalendarContainer>
      </div>
      {mediaIsPhone ? (
        <ModalEvents />
      ) : (
        <div>
          <BoxContainer>
            <Header>
              <Text type="h3">Eventi</Text>
              <SelectedDate>
                {selectedDate ? (
                  <p>
                    {dayjs(new Date(selectedDate * 1000))?.format('DD/MM/YYYY')}
                  </p>
                ) : (
                  <p>Prossimi eventi</p>
                )}
              </SelectedDate>
            </Header>
            <Body>
              {sessions.length > 0 ? (
                sessions.map((item, i) => (
                  <EventCard key={`card-event-${item.event_id}-${i}`}>
                    <Text
                      type="h3.5"
                      className="title"
                      mb={8}
                      onClick={() =>
                        navigate(
                          `${routes.courseDetails.path}/${item.event_id}/panoramica`
                        )
                      }
                    >
                      {item?.event_title}
                    </Text>
                    <Text type="b5" mb={8} className="line-clamp">
                      {item?.description}
                    </Text>
                    <div className="info">
                      <div className="d-flex">
                        {!selectedDate &&
                          timestampToDate(item?.activity_date, 'DD/MM/YY')}
                        &nbsp;&nbsp;
                        {item?.session_start}{' '}
                        <Icon type="clock" size={14} clickable={false} />
                      </div>
                      <div className="d-flex">
                        {item?.activity_type === 'activity_session_virtual_room'
                          ? 'Online'
                          : `${item?.city || 'In loco'}`}
                        <Icon
                          type={
                            item?.activity_type ===
                            'activity_session_virtual_room'
                              ? 'globe-02'
                              : 'marker-pin-01'
                          }
                          size={14}
                          clickable={false}
                        />
                      </div>
                    </div>
                  </EventCard>
                ))
              ) : (
                <NoResultContainer>
                  <NoResult text="Nessun evento disponibile" />
                </NoResultContainer>
              )}
            </Body>
          </BoxContainer>
        </div>
      )}
    </PlannedListGrid>
  );
};

LearningEvents.propTypes = {
  mediaIsPhone: PropTypes.bool,
  // HOC (connect, state)
  eventDates: PropTypes.array,
  sessions: PropTypes.array.isRequired,
  // HOC (connect, dispatch)
  getEventDatesList: PropTypes.func.isRequired,
  getEventsList: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default connect(
  (state) => {
    const { dates: eventDates, sessions } = state.events;

    return {
      eventDates,
      sessions,
    };
  },
  (dispatch) => ({
    getEventDatesList: (filters) =>
      dispatch({ type: EVENT_DATES_LIST_GET._REQUEST, filters }),
    getEventsList: (filters) =>
      dispatch({
        type: SESSIONS_LIST_GET._REQUEST,
        filters,
        keepAllSessions: true,
      }),
    modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
  })
)(withMediaQueries(LearningEvents));
